import { render, staticRenderFns } from "./createCohort.vue?vue&type=template&id=18e23db8&"
import script from "./createCohort.vue?vue&type=script&lang=js&"
export * from "./createCohort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports